import { IServiceClient } from 'src/interfaces/serviceClient';
import { isWhatsappAvaible } from 'src/modules/store/helpers';
import { isPluginAvailable } from 'src/utils/store/isPluginAvailable';
import { WSP_PLUGIN } from 'src/constants/plugins';

export const canSendWhatsAppToServiceClient = (
    client: IServiceClient | null
): boolean => {
    if (
        !client ||
        !client.store ||
        typeof client.store === 'string' ||
        !client.store._id
    ) {
        return false;
    }

    const store = client.store;
    const type = client.type;

    if (!store.areas || !isWhatsappAvaible({ area: type, areas: store.areas })) {
        return false;
    }

    return isPluginAvailable(store, WSP_PLUGIN);
};

